export default __webpack_public_path__ + "static/media/icon-course-objectives.2ba3a484.svg";